import { css } from '@emotion/core'
import parse from 'html-react-parser'
import React from 'react'

import { breakpoints } from '../constants/breakPoints'
import Chevron from '../icons/abstract/chevron.svg'
import { GlossaryTermPageProps } from '../interfaces/glossary'

// export for Competitor.tsx, competitor-info.ts
export interface FAQProps {
  question: string
  answer: string
  blackBG?: boolean
  withBlueChevron?: boolean
}

export const FAQ: React.FC<FAQProps> = ({ question, answer, blackBG = false, withBlueChevron = false }) => {
  const [toggle, setToggle] = React.useState(false)
  const [answerHeight, setAnswerHeight] = React.useState(0)
  const ref = React.useRef<HTMLDivElement>(null)

  return (
    <div
      onClick={() => {
        if (!toggle) {
          setToggle((value: boolean) => !value)
        }
        if (ref.current) {
          setAnswerHeight(ref.current?.scrollHeight)
        }
      }}
      css={FAQStyle(toggle, blackBG)}
    >
      <div
        onClick={() => {
          if (toggle) {
            setToggle((value: boolean) => !value)
          }
        }}
        className="strong-body-1"
        css={titleFAQ(blackBG, toggle)}
      >
        {parse(question)}
        <Chevron css={[icon(blackBG, withBlueChevron), toggle && iconActive]} />
      </div>
      <div ref={ref} className="body-1" css={[answerFAQ(blackBG), toggle && openFAQ(answerHeight)]}>
        {parse(answer)}
      </div>
    </div>
  )
}

export const FAQdata = (
  frequentlyAskedQuestions: GlossaryTermPageProps['data']['glossaryTerm']['frequentlyAskedQuestions']
) => {
  return frequentlyAskedQuestions?.map(
    (faq) =>
      `{
        "@type": "Question",
        "name": "${faq.question.question}",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "${faq.answer.answer}"
        }
      }`
  )
}

const icon = (blackBG: boolean, withBlueChevron: boolean) => css`
  transition: all 0.3s ease;
  ${blackBG && 'path { stroke: #fff; };'};
  ${withBlueChevron && 'path { stroke: #318eff; };'};
`

const iconActive = css`
  transform: rotateZ(180deg);
`

const titleFAQ = (blackBG: boolean, toggle: boolean) => css`
  display: grid;
  margin-bottom: 0.75rem;
  align-items: center;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  grid-gap: 0.5rem;
  grid-template-columns: auto min-content;
  ${blackBG && 'color: #fff;'};
  ${toggle && 'cursor: pointer'};
`

const answerFAQ = (blackBG: boolean) => css`
  color: ${blackBG ? '#fff' : '#4f616f'};
  overflow: hidden;
  max-height: 0;
  transition: all 0.3s ease-out;
`

const openFAQ = (answerHeight: number) => css`
  max-height: ${answerHeight}px;
  transition: all 0.3s ease-out;
`

// export for pricing.tsx & AdPageCompetitor2024.tsx
export const FAQContainer = css`
  width: 66%;
  margin: 1rem auto 0;
  display: grid;
  grid-gap: 0.5rem;

  @media screen and (max-width: ${breakpoints.medium}px) {
    width: 100%;
  }
`

const FAQStyle = (toggle: boolean, blackBG: boolean) => css`
  position: relative;
  padding: ${toggle ? '1.5rem 2rem 1.5rem 2rem' : '1.5rem 2rem 0.75rem 2rem'};
  ${!toggle && 'cursor: pointer'};
  background-color: ${toggle ? '#fafbfc' : '#fff'};
  background-color: ${blackBG && toggle ? 'rgba(255, 255, 255, 0.2)' : blackBG && 'rgba(255, 255, 255, 0.1)'};
  border-radius: 0.25rem;
  border: solid 1px ${blackBG ? 'rgba(255, 255, 255, 0.1)' : '#efeff0'};

  .body-1 {
    margin: 0;
  }

  &:hover {
    background-color: ${blackBG ? 'rgba(255, 255, 255, 0.2)' : '#fafbfc'};
  }
`
